import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Updates from './components/Updates';
import Contact from './components/Contact';
import Media from './components/Media';
import Topics from './components/Topics';
import Ranking from './components/Ranking';
import IndexSection from './components/IndexSection';
import Cards from './components/Cards';
import Comments from './components/Comments';
import Faq from './components/Faq';
import Carousel from './components/Carousel';
import About from './components/About';
import AppDownload from './components/AppDownload';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Updates />
        <Contact />
        <Media />
        <Topics />
        <Ranking />
        <IndexSection />
        <Cards />
        <Comments />
        <Faq />
        <Carousel />
        <About />
        <AppDownload />
      </main>
      <Footer />
    </>
  );
}